import psyImages from "../../components/utility/psychologicalImageImports";
const gardenChoicesSrb = [
  {
    label: "Зен врт са минималистичким сивим камењем и црним песком.",

    value:
      'A zen garden with minimalist gray stones and black sand.{"Gray":"3","Black":"2"}',
    imageUrl: psyImages["garden/forFormA.jpg"],
  },

  {
    label: "Живахан цветни врт са црвеним ружама и жутим сунцокретима.",
    value:
      'A vibrant flower garden with red roses and yellow sunflowers.{"Red":"3","Yellow":"2"}',
    imageUrl: psyImages["garden/forFormB.jpg"],
  },

  {
    label: "Мирни врт са водом, плавим љиљанима и љубичастим перуникама.",
    value:
      'A peaceful garden with water, blue lilies, and purple irises.{"Blue":"3","Violet":"2"}',
    imageUrl: psyImages["garden/forFormC.jpg"],
  },

  {
    label: "Бујни повртњак са зеленим биљкама и земљаним браон тлом.",
    value:
      'A lush vegetable garden with green plants and earthy brown soil.{"Green":"3","Brown":"2"}',
    imageUrl: psyImages["garden/forFormD.jpg"],
  },
];

export default gardenChoicesSrb;
